module.exports = __webpack_public_path__ + "assets/b2e501f12d63290a536ada0eeb4d3013.mp3";